import { useStaticQuery, graphql } from 'gatsby';

import { QueryFragments } from './queryFragments'; // eslint-disable-line

export const useHeaderQuery = () => {
  const { sanitySettingsNav } = useStaticQuery(graphql`
    query {
      sanitySettingsNav {
        mainMenu {
          mainLink {
            ...PageLink
          }
          subLinks {
            link {
              ...PageLink
            }
          }
        }
        serviceMenu {
          ...PageLink
        }
        logo {
          ...ImageWithPreview
        }
        reversedLogo {
          ...ImageWithPreview
        }
        animatedLogo {
          asset {
            url
          }
        }
      }
    }
  `);
  return sanitySettingsNav || {};
};
